import type {
  BankCatalogItem,
  BusinessDetailCatalogItem,
  CatalogServiceResponse,
  MunicipalityCatalogItem,
  NeighborhoodCatalogItem,
  ProvinceCatalogItem,
  SectorCatalogItem,
} from "@/services/assistedAffiliation/types";
import type { SelectOption } from "../types";

export const getCatalogData = <T,>(
  response: CatalogServiceResponse<T>
): T[] => {
  if (response?.status !== 200 || !Array.isArray(response.data)) return [];
  return response.data;
};

export const mapProvincesToOptions = (
  provinces: ProvinceCatalogItem[]
): SelectOption[] =>
  provinces.map((province) => ({
    label: province.province_name,
    value: province.province_id,
  }));

export const mapMunicipalitiesToOptions = (
  municipalities: MunicipalityCatalogItem[]
): SelectOption[] =>
  municipalities.map((municipality) => ({
    label: municipality.municipality_name,
    value: municipality.municipality_id,
  }));

export const mapSectorsToOptions = (
  sectors: SectorCatalogItem[]
): SelectOption[] =>
  sectors.map((sector) => ({
    label: sector.zone_name,
    value: sector.zone_id,
  }));

export const mapNeighborhoodsToOptions = (
  neighborhoods: NeighborhoodCatalogItem[]
): SelectOption[] =>
  neighborhoods.map((neighborhood) => ({
    label: neighborhood.neighborhood_name,
    value: neighborhood.neighborhood_id,
  }));

export const mapBanksToOptions = (banks: BankCatalogItem[]): SelectOption[] =>
  banks.map((bank) => ({
    label: bank.bank_name,
    value: bank.bank_id,
  }));

export const mapBusinessDetailsToOptions = (
  businessDetails: BusinessDetailCatalogItem[]
): SelectOption[] =>
  businessDetails
    .map((businessDetail) => {
      const value =
        businessDetail.mcc ||
        String(businessDetail.detail_id || "") ||
        businessDetail.business_detail_id ||
        String(businessDetail.id || "");
      const label =
        businessDetail.detail_name_es ||
        businessDetail.detail_category ||
        businessDetail.business_detail_name ||
        businessDetail.description ||
        businessDetail.name ||
        "";

      return { label, value };
    })
    .filter((option) => option.label && option.value);

